import styled from 'styled-components';

const Dot = styled.span`
    height: 10px;
    width: 10px;
    border-radius: 50%;
    display: inline-block;
    margin-right: 10px;
    background-color: ${({ colour }) => colour};
`;

export default Dot;
